module.exports = __webpack_public_path__ + "static/img/icon2.1644f097.png";